import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

// Styling
import 'bootstrap/dist/css/bootstrap.min.css';

// Pages
import { RobotRegFormPage } from './features/RobotRegForm/pages/RobotRegFormPage';
import { RobotRegResultPage } from './features/RobotRegForm/pages/RobotRegResultPage';
import { SupportRequestFormPage } from './features/SupportRequestForm/pages/SupportRequestFormPage';
import { SupportRequestResultPage } from './features/SupportRequestForm/pages/SupportRequestResultPage';

function App() {
  return (
    <BrowserRouter>
      <div>
        <Routes>
          {/* <Route path="/" element={<RobotRegFormPage />} />
          <Route path="/robot-reg/result" element={<RobotRegResultPage />} /> */}
          <Route path="/" element={<SupportRequestFormPage />} />
          <Route path="/result" element={<SupportRequestResultPage />} />
        </Routes>

        <ToastContainer position="top-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
